<template>
  <div class="row content mx-sm-0">
    <ListOneCategory category="herbs" :data="categories.herbs" />
    <ListOneCategory category="vegetables" :data="categories.vegetables" />
    <ListOneCategory category="fruits" :data="categories.fruits" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ListOneCategory from './ListOneCategory.vue';

export default {
  components: {
    ListOneCategory
  },
  computed: mapState([
    // map this.count to store.state.count
    'categories'
  ])
};
</script>
